import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

/**
 * Tracks the current page/module name derived from the deepest route breadcrumb.
 * Injected into NotificationEffects so every activity-log entry carries the
 * module the user was in when the notification was triggered.
 *
 * Examples: 'Campaigns', 'Customers', 'User Management', 'Integrations'
 */
@Injectable({ providedIn: 'root' })
export class RouteContextService {
  private _currentModule = '';

  get currentModule(): string {
    return this._currentModule;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      this._currentModule = this.getLeafBreadcrumb(this.route.root);
    });
  }

  /** Walks the activated route tree and returns the deepest breadcrumb label found. */
  private getLeafBreadcrumb(route: ActivatedRoute): string {
    let label = '';
    for (const child of route.children) {
      const crumb = child.snapshot.data['breadcrumb'];
      if (crumb) label = crumb;
      const deeper = this.getLeafBreadcrumb(child);
      if (deeper) label = deeper;
    }
    return label;
  }
}
